import { purgeToolbarParams, stripToolbarHashParams } from "@/utils/posthog_toolbar_guard";

// This is its own entrypoint, loaded before inertia.tsx in
// app/views/layouts/application.html.erb, because posthog-js reads
// location.hash at module scope and caches the result. Params must be
// cleaned before the posthog-js module body evaluates.
//
// Do not import posthog-js here or from posthog_toolbar_guard.ts, directly or
// transitively. Doing so evaluates posthog-js first, the snapshot captures the
// payload, and this defense stops working.

purgeToolbarParams();
stripToolbarHashParams();
